import { render, staticRenderFns } from "./PageBuilderComponent.vue?vue&type=template&id=685ec66e"
import script from "./PageBuilderComponent.vue?vue&type=script&lang=ts"
export * from "./PageBuilderComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports